// 지출 결의서 타입·상태 표시(목록 화면과 인쇄 양식이 같이 쓴다).

export type RequestStatus = 'requested' | 'dept_approved' | 'finance_approved' | 'paid' | 'rejected';

export type ExpenseRequest = {
  id: number;
  title: string;
  department: string;
  category: string;
  amount: number;
  requestDate: string;
  requesterName: string;
  payee: string;
  payMethod: string;
  bankAccount: string;
  description: string;
  status: RequestStatus;
  deptApproverName: string;
  deptApprovedAt: string | null;
  financeApprovedAt: string | null;
  paidDate: string | null;
  paidRecordId: number | null;
  rejectReason: string;
  rejectedAt: string | null;
  createdAt: string;
  attachmentCount?: number;
  attachments?: { id: number; originalName: string; mimeType: string; size: number }[];
};

export const STATUS_INFO: Record<RequestStatus, { label: string; badge: string }> = {
  requested: { label: '부서장 승인 대기', badge: 'manage-badge--amber' },
  dept_approved: { label: '재정부 승인 대기', badge: 'manage-badge--blue' },
  finance_approved: { label: '지급 대기', badge: 'manage-badge--purple' },
  paid: { label: '지급 완료', badge: 'manage-badge--green' },
  rejected: { label: '반려', badge: 'manage-badge--red' },
};
